import styled, { css } from 'styled-components';
import { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM } from '../../styles/General';

export interface BasicGridProps {
  gridColumns?: string;
}

export interface BasicGridItemProps {
  gridCol?: string;
  gridColSM?: string;
  gridColMD?: string;
  gridColLG?: string;
  gridSpan?: string;
  gridSpanSM?: string;
  gridSpanMD?: string;
  gridSpanLG?: string;
}

export const basicGrid = css<BasicGridProps>`
  display: grid;
  grid-template-columns: repeat(${({ gridColumns }) => gridColumns ? gridColumns : '12'}, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  width: 100%;
`;

export const basicGridItem = css<BasicGridItemProps>`
  grid-column: 1 / span ${({ gridCol }) => gridCol ? gridCol : '12'};

  ${({ gridColSM, gridSpanSM }) => gridColSM && css`
    ${BREAKPOINT_SM} {
      grid-column: ${ gridSpanSM ? gridSpanSM + ' / ' : ''}span ${gridColSM};
    }
  `};
  
  ${({ gridColMD, gridSpanMD }) => gridColMD && css`
    ${BREAKPOINT_MD} {
      grid-column: ${ gridSpanMD ? gridSpanMD + ' / ' : ''}span ${gridColMD};
    }
  `};

  ${({ gridColLG, gridSpanLG }) => gridColLG && css`
    ${BREAKPOINT_LG} {
      grid-column: ${ gridSpanLG ? gridSpanLG + ' / ' : ''}span ${gridColLG};
    }
  `};
`;

export const BasicGridWrapper = styled.div<BasicGridProps>`
  ${basicGrid};
`;

export const BasicGridItem = styled.div<BasicGridItemProps>`
  ${basicGridItem};
`;
